const API_URL = process.env.REACT_APP_BACKEND_URL;

async function request(path, { method = "GET", token, payload } = {}) {
  const headers = {};
  if (payload) headers["Content-Type"] = "application/json";
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers,
    body: payload ? JSON.stringify(payload) : undefined,
  });
  if (!res.ok) {
    let detail = "request_failed";
    try {
      const data = await res.json();
      if (typeof data.detail === "string") detail = data.detail;
    } catch {}
    throw new Error(detail);
  }
  return res.json();
}

const post = (path, payload) => request(path, { method: "POST", payload });
const get = (path, token) => request(path, { token });

export const postContact = (payload) => post("/api/contact", payload);
export const postConference = (payload) => post("/api/conferences", payload);
export const postNewsletter = (payload) => post("/api/newsletter", payload);

export const adminLogin = (payload) => post("/api/auth/login", payload);
export const adminMe = (token) => get("/api/auth/me", token);
export const adminGetMessages = (token) => get("/api/contact", token);
export const adminGetConferences = (token) => get("/api/conferences", token);
export const adminGetSubscribers = (token) => get("/api/newsletter", token);
export const adminSetContactStatus = (token, id, status) =>
  request(`/api/contact/${id}`, { method: "PATCH", token, payload: { status } });
export const adminSetConferenceStatus = (token, id, status) =>
  request(`/api/conferences/${id}`, { method: "PATCH", token, payload: { status } });
export const adminSendNewsletter = (token, payload) =>
  request("/api/newsletter/send", { method: "POST", token, payload });
export const adminGetCampaigns = (token) => get("/api/campaigns", token);

export const getLinks = () => get("/api/settings/links");
export const adminSetLinks = (token, payload) =>
  request("/api/settings/links", { method: "PUT", token, payload });
export const getAnnouncement = () => get("/api/settings/announcement");
export const adminSetAnnouncement = (token, payload) =>
  request("/api/settings/announcement", { method: "PUT", token, payload });
export const getAvailability = () => get("/api/settings/availability");
export const adminSetAvailability = (token, payload) =>
  request("/api/settings/availability", { method: "PUT", token, payload });

export const getArticles = () => get("/api/articles");
export const adminGetArticles = (token) => get("/api/admin/articles", token);
export const adminCreateArticle = (token, payload) =>
  request("/api/admin/articles", { method: "POST", token, payload });
export const adminUpdateArticle = (token, id, payload) =>
  request(`/api/admin/articles/${id}`, { method: "PUT", token, payload });
export const adminDeleteArticle = (token, id) =>
  request(`/api/admin/articles/${id}`, { method: "DELETE", token });

export const getContent = () => get("/api/content");
export const adminSetContent = (token, values) =>
  request("/api/content", { method: "PUT", token, payload: { values } });

export const getProjects = () => get("/api/projects");
export const adminGetProjects = (token) => get("/api/admin/projects", token);
export const adminCreateProject = (token, payload) =>
  request("/api/admin/projects", { method: "POST", token, payload });
export const adminUpdateProject = (token, id, payload) =>
  request(`/api/admin/projects/${id}`, { method: "PUT", token, payload });
export const adminDeleteProject = (token, id) =>
  request(`/api/admin/projects/${id}`, { method: "DELETE", token });
